import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsActiveParams,
  GetMarathonsActiveResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMarathonsActive = createAsyncThunk<
  GetMarathonsActiveResponse,
  GetMarathonsActiveParams
>("marathons/getMarathonsActive", async (params, { rejectWithValue }) => {
  try {
    const data = await MarathonsAPI.getMarathonsActive(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while getting marathons active",
        error?.response?.data
      );
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting marathons active", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
